module.exports = __webpack_public_path__ + "static/media/help_nav.03390223.svg";